import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

import { connect } from "react-redux";

import { isAuthenticatedBoth } from "../../../../auth/authBoth";
import { bindActionCreators } from "redux";
import { storeVirtualAdDetails } from "../../../../actions/storeVirtualAdDetails";

function ConfirmBtnVirtual(props) {
  const [loading, setLoading] = useState(false);

  const showNotification = async () => {
    return new Promise((resolve) => {
      NotificationManager.success("Created successfully!", "Success");
      setTimeout(resolve, 2000);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // create product object
    const data = props.data;

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/v1/operator_posts`,
      data: data,
      headers: {
        Authorization: `Bearer ${isAuthenticatedBoth()}`,
      },
    })
      .then(async (res) => {
        await showNotification();
        setLoading(false);
        sessionStorage.removeItem("virtual_ad_data");

        const data = {};
        props.storeVirtualAdDetails(data);
        setTimeout(() => {
          props.history.push("/dashboard/ads-created-by-vertual-agent");
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <>
      <div className="ad-form-sec">
        <form noValidate>
          <button
            type="button"
            className="btn-submit mt-0"
            onClick={() => props.history.push("/dashboard/virtual-ad-create")}
            style={{
              width: "auto",
              float: "left",
              background: "#efefef",
            }}
          >
            <i className="fas fa-angle-left"></i> Back
          </button>
          <button
            type="button"
            className="btn-submit mt-0"
            onClick={handleSubmit}
            style={{ width: 100, float: "right" }}
          >
            {loading ? (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              "Confirm"
            )}
          </button>
        </form>
      </div>
      <NotificationContainer />
    </>
  );
}

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({ storeVirtualAdDetails }, dispatch);
};

const mapStateToProps = (state) => {
  return {
    data: state.virtualAd.data,
  };
};

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(withRouter(ConfirmBtnVirtual));
